import { Component, OnInit } from '@angular/core';
import { FormControl, FormControlName, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { User, Logueo } from '../models/user';
import { ParameterConst } from 'src/app/util/constant';
import { environment } from 'src/environments/environment'; 
import { LoginService } from './login.service';
import { AlertaService } from 'src/app/util/alerta.service';
import { MsjDialogService } from 'src/app/service/msjDialogService';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  hide = true;
  userForm: FormGroup;

  arrPerfiles;

  constructor(private _loginService: LoginService,private route: ActivatedRoute,
    private alertaService: AlertaService,private router: Router,
    private msjSnackBar : MsjDialogService) {
    this.setUserForm();
   }

  ngOnInit(): void {
  }

  setUserForm () {

    this.arrPerfiles = environment.perfiles;

    this.userForm = new FormGroup({
      username: new FormControl('', [Validators.required]),
      pass: new FormControl('', [Validators.required])
    });
  }


  verifyUser() {
    if (this.userForm.invalid) {
      return;
    }
    let user = new User;
    user.username = this.userForm.value.username;
    user.pass = this.userForm.value.pass;

    try {

      this._loginService.verifyUser(user).pipe().subscribe(data => {

         if(data+"" == "null" || data.data == 0){
          this.msjSnackBar.openMensaje("Usuario no encontrado en nuestros registros.",ParameterConst.MESSAGE_SERFOR);
        }else if(Object.keys(data[0]).length == 0){
          this.msjSnackBar.openMensaje("Usuario, contraseña o perfil incorrecto.",ParameterConst.MESSAGE_SERFOR);
        }else{
          localStorage.setItem(ParameterConst.USER_LOGIN, JSON.stringify(data[0]));
          localStorage.setItem(ParameterConst.TOKEN, JSON.stringify(data[0].keyhash));

          if(data[0].type == "D"){

            if(data[0].access == ParameterConst.MD5_ADMINISTRATOR){
              localStorage.setItem(ParameterConst.USER_MENU, JSON.stringify(environment.ADMINISTRATOR));
            }else if(data[0].access == ParameterConst.MD5_SUPERVISOR){
              localStorage.setItem(ParameterConst.USER_MENU, JSON.stringify(environment.SUPERVISOR));
            }else if(data[0].access == ParameterConst.MD5_RECORDER){
              localStorage.setItem(ParameterConst.USER_MENU, JSON.stringify(environment.RECORDER));
            }else if(data[0].access == ParameterConst.MD5_RECORDER_ADMINISTRATOR){
              localStorage.setItem(ParameterConst.USER_MENU, JSON.stringify(environment.RECORDER_ADMINISTRATOR));
            }else if(data[0].access == ParameterConst.MD5_SHIPPER){
              localStorage.setItem(ParameterConst.USER_MENU, JSON.stringify(environment.SHIPPER));
            }else if(data[0].access == ParameterConst.MD5_DELIVER){
              localStorage.setItem(ParameterConst.USER_MENU, JSON.stringify(environment.DELIVER));
            }
            
          }else if(data[0].typeuser == "N"){
            localStorage.setItem(ParameterConst.USER_MENU, JSON.stringify(environment.user));
          }else if(data[0].typeuser == "A"){
            localStorage.setItem(ParameterConst.USER_MENU, JSON.stringify(environment.agent));
          }else if(data[0].typeuser == "DL"){
            localStorage.setItem(ParameterConst.USER_MENU, JSON.stringify(environment.delivery));
          }

          this.router.navigate(['/admin/dashboard']);

        }
  
      },
      error=>{
        this.msjSnackBar.openMensaje(ParameterConst.API_DISCONNET,ParameterConst.MESSAGE_SERFOR);
      }
      );

    } catch (error) {
      this.alertaService.error(error);
    }
  }


  hasError(controlName: string) {
    return this.userForm.controls[controlName].invalid;
  }

  forgotPassword(){
    this.router.navigate(['/admin/solicitar']);
  }


}
